<form class="filters" [formGroup]="filterForm" (submit)="$event.preventDefault()">
  <div class="filters-body">
  <div class="filters-head">
    <h2>Filtri</h2>
    <button class="filters-reset" type="button" (click)="resetFilters()">Azzera</button>
  </div>

  <section class="filters-section">
    <h3>Ricerca testuale</h3>
    <div class="filters-search">
      <label class="visually-hidden" for="title">Ricerca</label>
      <input id="title" class="field" type="text" placeholder="Nome, luogo o documento" formControlName="title"
        (keydown.enter)="searchArticles(0)">
      <button class="filters-go" type="button" (click)="searchArticles(0)">Cerca</button>
    </div>
  </section>

  <section class="filters-section">
    <h3>Categorie</h3>
    <div class="filters-chips">
      @for (category of categoryOptions; track category.id) {
        <label class="chip">
          <input type="checkbox" [id]="'cat_' + category.id" [checked]="isSelected(category)"
            (change)="toggleCategory(category)">
          <span>{{ category.title }}</span>
        </label>
      }
    </div>
  </section>

  <section class="filters-section">
    <h3>Città</h3>
    <label class="visually-hidden" for="city">Comune</label>
    <input id="city" class="field" type="text" placeholder="Comune" matInput [matAutocomplete]="city"
      formControlName="city"
      [class.is-invalid]="filterForm.get('city')?.invalid && (filterForm.get('city')?.dirty || filterForm.get('city')?.touched) && filterForm.get('city')?.value !== null">
    <mat-autocomplete #city="matAutocomplete" class="archive-city-panel" [displayWith]="displayCityName">
      @for (option of filteredCity$ | async; track option.id) {
        <mat-option [value]="option">{{ option.name }}</mat-option>
      }
    </mat-autocomplete>
  </section>

  <section class="filters-section">
    <h3>Luogo d'interesse</h3>
    <label class="visually-hidden" for="pointofinterest">Luogo</label>
    <input id="pointofinterest" class="field" type="text" placeholder="Luogo" formControlName="pointofinterest">
  </section>

  <section class="filters-section">
    <h3>Data</h3>
    <div class="format-switch" role="group" aria-label="Formato data">
      <input type="radio" name="yearFormat" id="date" (click)="changeFormat('date')" [checked]="yearFormat === 'date'">
      <label for="date">Data</label>

      <input type="radio" name="yearFormat" id="year" (click)="changeFormat('year')" [checked]="yearFormat === 'year'">
      <label for="year">Anno</label>

      <input type="radio" name="yearFormat" id="period" (click)="changeFormat('period')" [checked]="yearFormat === 'period'">
      <label for="period">Periodo</label>
    </div>

    @if (yearFormat == 'date') {
      <input class="field" type="date" aria-label="Data" formControlName="date_article">
    }

    @if (yearFormat == 'year') {
      <input id="year_article" class="field" type="text" placeholder="Anno singolo" formControlName="year_article"
        [class.is-invalid]="filterForm.get('year_article')?.invalid && (filterForm.get('year_article')?.dirty || filterForm.get('year_article')?.touched)">
    }

    @if (yearFormat == 'period') {
      <div class="filters-period">
        <input id="yearFrom_article" class="field" type="text" placeholder="Dal" formControlName="yearFrom_article"
          (input)="validPeriod()"
          [class.is-invalid]="filterForm.get('yearFrom_article')?.invalid && (filterForm.get('yearFrom_article')?.dirty || filterForm.get('yearFrom_article')?.touched)">
        <input id="yearTo_article" class="field" type="text" placeholder="Al" formControlName="yearTo_article"
          (input)="validPeriod()"
          [class.is-invalid]="filterForm.get('yearTo_article')?.invalid && (filterForm.get('yearTo_article')?.dirty || filterForm.get('yearTo_article')?.touched)">
      </div>
    }
  </section>
  </div>

  <button class="filters-submit" type="button" (click)="searchArticles(1)" [disabled]="filterForm.invalid">
    Applica filtri
  </button>
</form>
